export default __webpack_public_path__ + "img/fef314a17af2de6ba8e3102d6b334707.png";